import React from 'react'
import { usePickByLanguage } from '@/hooks/use-pick-by-language'
import { CheckinReceiptSheet } from '@/utils/checkin-receipt-sheets'
import { SheetHeading } from './sheet-heading'
import { RoomSection } from './room-section'
import { StaySection } from './stay-section'
import { PaymentSection } from './payment-section'
import { GuestAppSection } from './guest-app-section'
import { receiptSheetStyle } from './receipt-sheet-style'

type Props = {
  sheet: CheckinReceiptSheet
}

export const ReceiptSheet = React.forwardRef<HTMLDivElement, Props>(({ sheet }, ref) => {
  const pickByLanguage = usePickByLanguage()
  return (
    <div ref={ref} css={receiptSheetStyle}>
      <SheetHeading {...sheet.heading} />
      <div className="accommodation-block">
        <div>
          <div>{sheet.room && <RoomSection room={sheet.room} />}</div>
          <StaySection stay={sheet.stay} />
          <hr className="-normal" />
        </div>
        <div className="comment">{pickByLanguage(sheet.hotelComment)}</div>
      </div>

      <hr className="-block" />

      {sheet.payment && <PaymentSection payment={sheet.payment} />}
      <GuestAppSection guestAppUrl={sheet.guestAppUrl} />
    </div>
  )
})
ReceiptSheet.displayName = 'ReceiptSheet'
